// Convert a product name + id into an SEO-friendly URL slug
// e.g. "Women's Floral Summer Dress" + 2772 → "womens-floral-summer-dress-2772"
export function productSlug(name, id) {
  const slug = (name || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')   // remove special chars
    .trim()
    .replace(/\s+/g, '-')            // spaces → hyphens
    .replace(/-+/g, '-')             // collapse multiple hyphens
    .substring(0, 60);               // max 60 chars
  return `${slug}-${id}`;
}

// Extract the numeric ID from the end of a slug URL param
// e.g. "womens-floral-summer-dress-2772" → "2772"
export function idFromSlug(slugParam) {
  const parts = (slugParam || '').split('-');
  return parts[parts.length - 1];
}
